module.exports = __webpack_public_path__ + "img/profile_PYP.5b28f87d.jpeg";